import { create } from "zustand";
import { calculatePositionPnL } from "../../utils/calculatePositionPnL";


// Throttling State
let ltpBuffer = new Map();
let throttleTimer = null;
const THROTTLE_DELAY = 500; // 500ms = 2 updates/sec

export const usePositionStore = create((set, get) => ({

  positions: [],
  version: 0,   // 🔥 UI re-render trigger

  //-------------------------------------------
  // INITIAL LOAD
  //-------------------------------------------
  setInitialPositions: (positions) => {
    set({
      positions,
      version: get().version + 1,
    });
  },

  //-------------------------------------------
  // ADD / UPDATE POSITION (by ID only)
  //-------------------------------------------
  addOrUpdatePosition: (incoming) => {
    set((state) => {
      const incomingId = String(incoming.id);

      const idx = state.positions.findIndex(
        (p) => String(p.id) === incomingId
      );

      let newPositions;

      if (idx !== -1) {
        // console.log(
        //   `🔄 Updating Position → ID: ${incomingId}, Symbol: ${incoming.symbol}`
        // );

        newPositions = [...state.positions];
        newPositions[idx] = {
          ...newPositions[idx],
          ...incoming,
          last_updated: new Date().toISOString(),
        };
      } else {
        // console.log(
        //   `🟢 Adding NEW Position → ID: ${incomingId}, Symbol: ${incoming.symbol}`
        // );

        newPositions = [...state.positions, incoming];
      }

      return {
        positions: newPositions,
        version: state.version + 1, // 🔥 force UI update
      };
    });
  },

  //-------------------------------------------
  // REMOVE POSITION (old 3-key match)
  //-------------------------------------------
  removePosition: ({ client_id, symbol, strategy }) => {
    set((state) => ({
      positions: state.positions.filter(
        (p) =>
          !(
            String(p.client_id) === String(client_id) &&
            String(p.symbol) === String(symbol) &&
            String(p.strategy) === String(strategy)
          )
      ),
      version: state.version + 1,
    }));
  },

  //-------------------------------------------
  // REMOVE BY ID
  //-------------------------------------------
  removePositionById: (id) => {
    if (!id) return;

    console.log(`🗑️ Removing Position → ID: ${id}`);

    set((state) => ({
      positions: state.positions.filter(
        (p) => String(p.id) !== String(id)
      ),
      version: state.version + 1,
    }));
  },

  //-------------------------------------------
  // UPDATE LTP + PNL (THROTTLED)
  //-------------------------------------------
  updatePositionLtp: (symbol, ltp, timestamp) => {
    // 1. Buffer the update
    ltpBuffer.set(symbol, { ltp, timestamp });

    // 2. Schedule flush if not already scheduled
    if (!throttleTimer) {
      throttleTimer = setTimeout(() => {
        const updates = new Map(ltpBuffer);
        ltpBuffer.clear();
        throttleTimer = null;

        const state = get();
        
        // CRITICAL PERFORMANCE FIX:
        // Instead of using 'set' which triggers global re-renders for every subscriber,
        // we update the objects in-place within the array. 
        // This is safe here because we are NOT changing the array structure/reference,
        // and our "Optimized" cells will pick up these changes via their own subscriptions.
        
        state.positions.forEach((p) => {
          const update = updates.get(p.symbol);
          if (update) {
            // Update the object properties directly
            p.ltp = update.ltp;
            p.current_ltp = update.ltp;
            p.pl = calculatePositionPnL(p, update.ltp);
            p.last_updated = update.timestamp || new Date().toISOString();
          }
        });

        // We DO NOT call set() or increment version here.
        // This stops the re-render storm.
      }, THROTTLE_DELAY);
    }
  },

}));
